import accessToken from './accessToken';
import createPasswordIsLoading from './createPasswordIsLoading';
import editCompanyIsLoading from './editCompanyIsLoading';
import editIsLoading from './editIsLoading';
import forgotPasswordEmail from './forgotPasswordEmail';
import forgotPasswordIsLoading from './forgotPasswordIsLoading';
import profile from './profile';
import resetPasswordIsLoading from './resetPasswordIsLoading';
import signInIsLoading from './signInIsLoading';
import userRole from './userRole';

const authSelectors = {
  editIsLoading,
  createPasswordIsLoading,
  userRole,
  accessToken,
  profile,
  editCompanyIsLoading,
  forgotPasswordIsLoading,
  forgotPasswordEmail,
  resetPasswordIsLoading,
  signInIsLoading,
};

export default authSelectors;
